<template>
  <div class="roll">
    <div class="swiper-container" :class="sname">
	    <div class="swiper-wrapper">

	    	<div class="swiper-slide">
	          <a :href="item.url" target="_bland" v-for="(item,index) in list" :key="index">
	            <img :src="item.picture" :alt="item.title" />
	          </a>
	        </div>
	    </div>
    
		<!-- <div class="swiper-button-prev"></div>
		<div class="swiper-button-next"></div> -->
		<!-- <div class="swiper-pagination"></div> -->
		<!-- <div class="swiper-scrollbar"></div> -->
	</div>     
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css';
let progress;
let effect = 0

export default {
  name: 'roll',
  props:{
    list:{type:Array,default:()=>[]},
    speed:{type:Number,default:200000},
    sname:{type:String,default:'sn'}
  },
  mounted(){
    this.$nextTick( () => {
      setTimeout(()=>{
      	this.swiper = new Swiper('.'+this.sname, {
			slidesPerView: 'auto',
		    spaceBetween: 30,
		    speed:this.speed,
			autoplay: {
			    delay: 0,
			    stopOnLastSlide: false,
			    disableOnInteraction: true,
			},
			loop:true,
		});
      },2000)
    })
  }
}
</script>

<style scoped>
.roll{display:flex; flex-wrap:wrap; margin:1vw 6.23428859vw 1.5vw 6.23428859vw}
.roll>.swiper-container{margin:1vw 0; width:100%; }

.roll>.swiper-container .swiper-slide{white-space:nowrap; width:auto;}
.roll>.swiper-container .swiper-slide a{display:inline-block; margin-right:10px;}
.roll>.swiper-container .swiper-slide a img{height:2.6vw;}
.roll>.swiper-container .swiper-slide a span{display:block; text-align: center; font-size:1vw;}

.swiper-container .swiper-wrapper{
    -webkit-transition-timing-function: linear;
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
}

@media (min-width: 992px){}
@media (max-width: 991px){
.roll>.swiper-container .swiper-slide a img{height:7.5vw;}
}
</style>